"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewAsset = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const text_area_1 = require("client/components/material/text-area");
const text_field_1 = require("client/components/material/text-field");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const store_1 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const react_1 = require("react");
const React = require("react");
const ReactTooltip = require("react-tooltip");
const upload_1 = require("shared/upload");
require("./review-asset.less");
const dummyAsset = {
    description: "",
    fileNewName: "",
    fileOriginalName: "",
    filePath: "",
    fileType: "",
    id: 0,
    localRemote: "",
    uploadDate: null,
    expDate: null,
    uploadUserId: 0,
    informationType: upload_1.InformationType.ProviderCredentials,
    approved: false,
    rejected: false,
    approvalDate: null,
    rejectReason: "",
    connectAssetId: null
};
let ReviewAsset = class ReviewAsset extends react_1.Component {
    constructor() {
        super(...arguments);
        this.assetModal = false;
        this.showConfirmationReject = false;
        this.handleConnectAssetUpdate = (value) => {
            this.asset.connectAssetId = Number(value);
            console.log("this asset when saving in dropdown select", this.asset);
        };
        this.renderModalConfirmRejection = () => {
            const renderReason = (React.createElement(text_area_1.MaterialTextArea, { className: "notes", onChange: this.handleChangeString("rejectReason"), placeholder: "Rejection Reason", value: this.asset.rejectReason && this.asset.rejectReason !== "null"
                    ? `${this.asset.rejectReason}`
                    : "" }));
            return (this.showConfirmationReject && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm Rejection", cancelText: "Cancel", message: `Are you sure you want to reject this asset? <br /><br />To proceed, please provide a rejection reason below.<br />`, addinModal: renderReason, onCancel: () => (this.showConfirmationReject = false), onConfirm: this.handleReject, title: "Confirm Rejection", shouldDisableConfirm: !this.asset.rejectReason })));
        };
        // endregion
        // region Event handlers
        this.handleChangeString = (fieldName) => (event, value) => {
            if (fieldName === "description") {
                this.asset[fieldName] = value;
            }
            if (fieldName === "rejectReason") {
                this.asset[fieldName] = value;
            }
        };
        this.handleChangeExpDate = (value) => {
            this.asset.expDate = value;
        };
        this.handleClickClearExpDate = () => {
            this.asset.expDate = null;
        };
        this.isChanged = () => {
            const result = ramda_1.difference(Object.entries(this.asset), Object.entries(ramda_1.merge(dummyAsset, this.props.asset)));
            return result.length > 0;
        };
        this.handleSubmit = () => {
            callable_1.callable(this.props.onSave)(this.asset, this.key);
        };
        this.handleConfirmReject = () => {
            this.showConfirmationReject = !this.showConfirmationReject;
        };
        this.handleReject = () => {
            callable_1.callable(this.props.onReject)(this.asset, this.key);
        };
        this.handleCancel = () => {
            this.props.onCancel();
        };
    }
    // region React
    componentWillMount() {
        this.asset = ramda_1.merge(dummyAsset, this.props.asset);
        this.key = this.props.indexkey;
        console.log("this.key in review asset", this.key);
    }
    async componentWillReceiveProps(props) {
        if (props.asset) {
            this.asset = ramda_1.merge(dummyAsset, props.asset);
        }
        if (props.indexkey) {
            this.key = props.indexkey;
        }
    }
    // endregion
    get sites() {
        return this.asset.provider.sites
            ? this.asset.provider.sites.map((site, i) => (React.createElement("li", { key: i }, site.displayName ? site.displayName : "")))
            : null;
    }
    render() {
        const { slim = false } = this.props;
        const asset = this.asset || dummyAsset;
        const isCsv = asset.filePath.includes(".csv") && !asset.filePath.includes(".txt");
        const canEdit = store_1.usersStore.permissions.ReadAssetApprovals;
        const sites = asset.provider.sites
            .map((site) => `${site.displayName}`)
            .join(",");
        return (React.createElement("div", { className: "review-asset" },
            React.createElement("a", { className: "close-button", onClick: this.handleCancel },
                React.createElement(icons_1.CloseIcon, null)),
            React.createElement("div", { className: "main" },
                React.createElement("div", { className: "main-left" },
                    React.createElement(material_ui_1.Typography, { align: "center", variant: "title" }, asset.fileOriginalName),
                    React.createElement("div", { className: "iframe-container" }, isCsv ? (React.createElement("div", null,
                        React.createElement(material_ui_1.Typography, { align: "center", variant: "title" }, "Preview of csv file format is not available. To view file, click on the Download button below."),
                        React.createElement("iframe", { className: "iframe-csv" }))) : (React.createElement("iframe", { className: "iframe", src: asset.filePath }))),
                    React.createElement("div", { className: "ui-form__buttons" },
                        React.createElement("a", { href: asset.filePath, download: asset.fileOriginalName },
                            React.createElement(button_1.MaterialButton, { flat: true }, "Download")))),
                React.createElement("div", { className: "asset-info" },
                    React.createElement(ui_1.UiForm, { buttons: canEdit && !this.props.rejected
                            ? [
                                React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                                React.createElement(button_1.MaterialButton, { className: "btnReject", onClick: this.handleConfirmReject }, "Reject"),
                                "Approve"
                            ]
                            : [
                                React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                                "Approve"
                            ], onSubmit: this.handleSubmit, loading: false, 
                        //   isChanged={this.isChanged}
                        //   status={this.props.status ? this.props.status : FormStatus.Clean}
                        saved: "Saved", error: this.props.error },
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "description" },
                                React.createElement(text_field_1.MaterialTextField, { disabled: !canEdit, autoFocus: this.props.autoFocusForm, className: "desc", label: "Description", onChange: this.handleChangeString("description"), value: `${asset.description}` || "" }))),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "exp-date" },
                                React.createElement(date_picker_1.MaterialDatePicker, { disabled: !canEdit, className: "expdate", label: "Exp Date", onChange: this.handleChangeExpDate, value: asset.expDate || null }),
                                React.createElement(button_1.MaterialButton, { className: "deaExp__clear-button", onClick: this.handleClickClearExpDate }, "Clear"))),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "connect-asset" },
                                React.createElement(select_1.MaterialSelect, { className: "connectasset", options: [...this.props.connectAssetCategories], searchable: true, label: "Requirement", onSelect: this.handleConnectAssetUpdate, value: `${asset.connectAssetId}` || "" }))),
                        this.props.rejected ? (React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "reject-reason" },
                                "Rejection Reason:",
                                React.createElement("br", null),
                                asset.rejectReason && asset.rejectReason !== "null"
                                    ? `${asset.rejectReason}`
                                    : ""))) : null,
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "prov-sites" },
                                "Provider is affiliated with the following pharmacies:",
                                React.createElement("br", null),
                                React.createElement("ul", { className: "prov-sites__site-list" }, this.sites)))))),
            this.showConfirmationReject && this.renderModalConfirmRejection(),
            React.createElement(ReactTooltip, { effect: "solid", place: "right", delayShow: 300, "data-type": "info", multiline: true })));
    }
};
__decorate([
    mobx_1.observable
], ReviewAsset.prototype, "asset", void 0);
__decorate([
    mobx_1.observable
], ReviewAsset.prototype, "key", void 0);
__decorate([
    mobx_1.observable
], ReviewAsset.prototype, "currentAssetViewing", void 0);
__decorate([
    mobx_1.observable
], ReviewAsset.prototype, "assetModal", void 0);
__decorate([
    mobx_1.observable
], ReviewAsset.prototype, "showConfirmationReject", void 0);
ReviewAsset = __decorate([
    mobx_react_1.observer
], ReviewAsset);
exports.ReviewAsset = ReviewAsset;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/asset-approvals/components/review-asset/review-asset.tsx
// module id = 3237
// module chunks = 0